// When to hide the left navigation panel (maximal size visible)
export const DesktopBreakpoint = "lg";
export const TabletBreakpoint = "md";
export const MobileBreakpoint = "xs";
